// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__rPvt1","balanceDisclaimer":"posDashboard_balanceDisclaimer__17ODI"};